import React, { JSX } from 'react';
import { classNames } from 'assets/utils/helper';

type DistanceFilterProps = {
  setDistance: Function;
  distance: string;
  disabled: boolean;
};

const DistanceFilter = (props: DistanceFilterProps): JSX.Element => {
  const { setDistance, disabled, distance } = props;
  return (
    <>
      {/* Sitecore Search Requires Distance in kilometers, so we pass that but display miles */}
      <div
        className={classNames(
          'distance-filter-wrapper',
          disabled ? 'disabled' : ''
        )}
      >
        <div className="filter-panel-header">
          <p className="distance-title">Distance From</p>
        </div>
        <div className="distance-radio">
          <div className="distance-radio-wrapper">
            <input
              onChange={() => {
                setDistance('5');
              }}
              type="radio"
              id="distance-5"
              checked={distance === '5'}
              name="distance"
              disabled={disabled}
            />
            <label
              htmlFor="distance-5"
              className={classNames(disabled ? 'disabled' : '')}
            >
              <p>5</p>
            </label>
          </div>
          <div className="distance-radio-wrapper">
            <input
              onChange={() => {
                setDistance('10');
              }}
              type="radio"
              id="distance-10"
              checked={distance === '10'}
              name="distance"
              disabled={disabled}
            />
            <label
              htmlFor="distance-10"
              className={classNames(disabled ? 'disabled' : '')}
            >
              <p>10</p>
            </label>
          </div>
          <div className="distance-radio-wrapper">
            <input
              onChange={() => {
                setDistance('25');
              }}
              type="radio"
              id="distance-25"
              checked={distance === '25'}
              name="distance"
              disabled={disabled}
            />
            <label
              htmlFor="distance-25"
              className={classNames(disabled ? 'disabled' : '')}
            >
              <p>25</p>
            </label>
          </div>
          <div className="distance-radio-wrapper">
            <input
              onChange={() => {
                setDistance('50');
              }}
              type="radio"
              id="distance-50"
              checked={distance === '50'}
              name="distance"
              disabled={disabled}
            />
            <label
              htmlFor="distance-50"
              className={classNames(disabled ? 'disabled' : '')}
            >
              <p>50</p>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default DistanceFilter;
